import React, {useEffect} from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { connect } from 'react-redux'

import { confirmAlert } from 'react-confirm-alert';
import {GenericTableButton, TranslateButton} from "../../../components/buttons/buttonsActions";
import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    LIST, NO, NO_DATA_FOUND, YES
} from "../../../components/i18n/i18n";

import {remove, search} from "../../../redux/actions/xeeker/vectorActions";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import VectorFilters from "./_filters";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {vectorService} from "../../../jwt/_services/xeeker/vectorService";
import TranslateItem from "../../../components/genericComponents/translateItem";

const VectorList = props => {
    const fbDataBaseId = props.app?.fbDataBase?.id

    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    useEffect(()=>{
        if(!filter)
            props.setFilter( {
                fbDataBase : { id : fbDataBaseId },
                item : { code : null }
            });
    },[])

    useEffect(() => {
        if(!filter)
            return

        refreshDataList(pageIndex, pageSize, filter);
    }, [filter, pageIndex, pageSize]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            props.remove(data.id)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const confirmTranslation = item => confirmAlert({
        closeOnEscape: false,
        closeOnClickOutside:false,
        customUI: ({onClose}) => <TranslateItem
            itemID = { item?.id }
            fbDB = { fbDataBaseId }
            onClose = { onClose }
            translate = { (itemID, fbDB) => vectorService.translate(itemID, {
                db: fbDB,
                app: props?.app?.id,
            }) }
        />
    });

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => {
            props.setViewMode('FORM');
            props.setItem(row);
            props.setForm(true, false, false);
        }}/>
        <TranslateButton onClick={() => confirmTranslation(row)}/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: 'uid',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'title',
            text: 'Titulo'
        }, {
            dataField: 'pointACode',
            text: 'Desde'
        }, {
            dataField: 'pointBCode',
            text: 'Hasta'
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerStyle: {width: '230px'},
            formatter: actionsFormatter
        }
    ];

    return ( <Card>

        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <VectorFilters />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || [] }
                columns={columns}
                noDataIndication={ NO_DATA_FOUND }
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card> )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    remove,
})

export default connect(mapStateToProps, mapActionsToProps)(VectorList)